export const UPDATE_FORM_FIELD = 'UPDATE_FORM_FIELD';
export const UPDATE_FORM = 'UPDATE_FORM';
export const UPDATE_FORM_SEARCH_CRITERIA = 'UPDATE_FORM_SEARCH_CRITERIA';
export const CLEAR_FORM = 'CLEAR_FORM';
export const RECEIVE_DATA = 'RECEIVE_DATA';
export const UPDATE_RESULTS = 'UPDATE_RESULTS';
export const LOAD_GLOBAL = 'LOAD_GLOBAL';
export const LOAD_GLOBALS = 'LOAD_GLOBALS';
